<template>
  <v-data-table
    :headers="headers"
    :items="getItems"
    :search="search"
    item-key="id"
    sort-by="origin_quantity_to_produce"
    :sort-desc="true"
    dense
    hide-default-footer
    :items-per-page="15"
    @page-count="pageCount = $event"
    :page.sync="page"
  >
    <template v-slot:item.quantity_required="{ item }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-row align="center" dense no-gutters>
            <span v-on="on">{{ item.quantity_required }}</span>
            <span class="caption  ml-1">{{ getProductUnit(item) }}</span>
          </v-row>
        </template>
        <div>
          <v-row align="center" no-gutters>
            <span class="subtitle-2 mr-3">Quantité directement demandé:</span>
            <span>{{ item.quantity_asked + item.quantity_to_add }}</span>
          </v-row>
          <v-row align="center" no-gutters>
            <span class="subtitle-2 mr-3"
              >Quantité demandé par d'autres recettes:</span
            >
            <span>{{ item.quantity_required_recipe }}</span>
          </v-row>
        </div>
      </v-tooltip>
    </template>
    <template v-slot:item.quantity_asked="{ item }">
      <span>{{ item.quantity_asked }}</span>
      <span class="caption ml-1">{{ getProductUnit(item) }}</span>
    </template>
    <template v-slot:item.quantity_inventory="{ item }">
      <!-- <span>{{ item.quantity_inventory }}</span>
      <span class="caption ml-1">{{ getProductUnit(item) }}</span> -->
      <j-decimal-input
        v-model="item.quantity_inventory"
        hide-details
        solo
        flat
        single-line
        dense
        unit-suffix
        :step="1"
        class="no-before my-1"
        :suffix="getProductUnit(item)"
        @input="update(item)"
        style="max-width: 150px;"
      ></j-decimal-input>
    </template>
    <template v-slot:item.quantity_to_produce="{ item }">
      <span v-show="item.quantity_to_produce > 0" class="font-weight-bold">{{
        item.quantity_to_produce
      }}</span>
      <span
        v-show="item.quantity_to_produce > 0"
        class="font-weight-bold caption ml-1"
        >{{ getProductUnit(item) }}</span
      >
    </template>
    <template v-slot:item.name="{ item }">
      <span class="font-weight-bold font-capitalize">{{ item.name }}</span>
    </template>
    <template v-slot:item.quantity_to_add="{ item }">
      <j-decimal-input
        v-model="item.quantity_to_add"
        hide-details
        filled
        single-line
        dense
        unit-suffix
        show-actions
        :step="1"
        class="no-before my-1"
        :suffix="getProductUnit(item)"
        @input="update(item)"
        style="max-width: 200px;"
      ></j-decimal-input>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-row align="center" justify="end" no-gutters>
        <v-tooltip left v-if="item.can_be_produce === false">
          <template v-slot:activator="{ on }">
            <v-icon
              v-if="item.can_be_produce === false"
              v-on="on"
              color="error"
              v-show="item.quantity_to_produce > 0"
            >
              fa-exclamation-triangle
            </v-icon>
          </template>
          <v-row align="center" no-gutters>
            <span
              >Ingrédient{{
                item.requirements.length > 0 ? "s" : ""
              }}
              manquant{{ item.requirements.length > 0 ? "s" : "" }}</span
            >
          </v-row>
          <v-row
            v-for="requirement in item.requirements.filter(
              x => x.available < 0
            )"
            align="center"
            no-gutters
            :key="requirement.productId"
          >
            <span class="font-weight-bold text-capitalize mr-1"
              >{{ requirement.product }}:</span
            >
            <span
              >{{ requirement.require | round2 }}
              {{ requirement.productInvUnit }}</span
            >
          </v-row>
        </v-tooltip>

        <v-btn
          class="ml-2"
          :small="!$vuetify.breakpoint.xsOnly"
          icon
          text
          v-show="item.quantity_to_produce > 0"
          @click="
            () => {
              item.quantity_asked = 0;
              update(item);
            }
          "
        >
          <v-icon>fa-times</v-icon>
        </v-btn>
      </v-row>
    </template>
    <template v-slot:top>
      <v-row justify="end" dense>
        <v-col cols="1" sm="6">
          <v-row justify="start" align="center" no-gutters>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon @click="showNoQuantity = !showNoQuantity" v-on="on">
                  <v-icon :style="{ opacity: showNoQuantity ? 1 : 0.3 }"
                    >fa-filter</v-icon
                  >
                </v-btn>
              </template>
              <span v-if="!showNoQuantity"
                >Afficher les produits hors gabarit</span
              >
              <span v-else>Cacher les produits hors gabarit</span>
            </v-tooltip>
          </v-row>
        </v-col>
        <v-col cols="11" sm="6">
          <v-text-field
            dense
            filled
            hide-details
            single-line
            clearable
            prepend-inner-icon="fa-search"
            v-model="search"
            class="no-before"
          ></v-text-field>
        </v-col>
      </v-row>
    </template>
    <template v-slot:footer>
      <v-pagination
        color="accent"
        v-model="page"
        :length="pageCount"
        :total-visible="5"
      ></v-pagination>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "PreparationSlipEditorGrid",
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters(["getRecipes"]),
    getItems() {
      const items = this.items.filter(x => x.est_intermediaire === true);
      if (this.showNoQuantity) {
        return items;
      } else {
        return items.filter(
          x =>
            x.quantity_asked !== 0 ||
            x.quantity_to_produce !== 0 ||
            x.origin_quantity_asked !== 0 ||
            x.force_show === true
        );
      }
    }
  },
  data() {
    return {
      showNoQuantity: false,
      search: "",
      tabs: 0,
      page: 1,
      pageCount: 0,
      headers: [
        { value: "name", text: "Nom" },
        { value: "quantity_asked", text: "Gabarit" },
        { value: "quantity_to_add", text: "Modifications" },
        { value: "quantity_inventory", text: "Inventaire" },
        { value: "quantity_to_produce", text: "Production" },
        { value: "actions", text: "" }
      ]
    };
  },
  methods: {
    getProductUnit(item) {
      const recipe = this.getRecipes.find(
        x => x.fk_produit_intermediaire === item.id
      );
      if (recipe) {
        if (recipe.data && recipe.data.use_conversion_formula) {
          return recipe.data.unite_inventory;
        } else {
          return recipe.unite_produite;
        }
      } else {
        return item.data && item.data.unite_mesure_inventory
          ? item.data.unite_mesure_inventory
          : item.data && item.data.unite_mesure
          ? item.data.unite_mesure
          : "";
      }
    },
    update(item) {
      this.$emit("update", item);
    }
  }
};
</script>

<style></style>
